/**
 * Alert Popup Manager
 * Call showAlert({ message, severity }) from anywhere (e.g. OrbieeFlow).
 * Mount AlertProvider in App.js to render AlterPopup.
 */

let alertState = {
  visible: false,
  message: "",
  severity: "info", // "success" | "error" | "warning" | "info"
};

let subscribers = [];

export function subscribe(callback) {
  subscribers.push(callback);
  callback(alertState);
  return () => {
    subscribers = subscribers.filter((sub) => sub !== callback);
  };
}

function notifySubscribers() {
  subscribers.forEach((cb) => cb(alertState));
}

/**
 * Show alert popup (uses AlterPopup.jsx when AlertProvider is mounted).
 * @param {Object} options
 * @param {string} options.message - Alert message
 * @param {string} [options.severity] - "success" | "error" | "warning" | "info"
 */
export function showAlert({ message = "", severity = "info" }) {
  alertState = {
    visible: true,
    message,
    severity,
  };
  notifySubscribers();
}

export function getAlertState() {
  return { ...alertState };
}

/**
 * Hide the current alert (called by AlertProvider after auto-dismiss or close).
 */
export function hideAlert() {
  alertState = { ...alertState, visible: false };
  notifySubscribers();
}
